import Vue from 'vue'
import '@/plugins/moment'
// import moment from 'moment-timezone'
import moment from 'moment'

Vue.filter('formatDate', function (date, format = 'DD/MM/YYYY') {
  return moment(date).format(format)
})
